<template>
  <Layout>
    <div class="row">
      <div class="col-md-12 mb-4 mx-auto" style="padding-bottom: 100px">
        <form @submit.prevent="onSubmit">
          <h5>{{ $t("pages.documentType.title_1") }}</h5>
          <div class="row mt-3">
            <div class="col-md-6">
              <label>{{ $t("pages.documentType.designation") }}</label>
              <input type="text" v-model.trim="forms.name" class="form-control" required />
            </div>
            <div class="col-md-6">
              <label>{{ $t("pages.documentType.description") }} </label>
              <input class="form-control" v-model="forms.description" rows="2" required />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-md-12">
              <label>{{ $t("pages.documentType.metadata") }}</label>
              <a href="#" @click="showModal = true" class="float-right text-success">
                + {{ $t("pages.documentType.new_metadata") }}
              </a>
              <multiselect v-model="forms.metadatas" :options="forms.metadata" :multiple="true"
                :tage-placeholder="$t('pages.documentType.search')" :placeholder="$t('pages.documentType.tag')"
                label="label" track-by="id" :taggable="true" @tag="addTag"></multiselect>
            </div>
            <div class="col-2">
              <b-modal id="modal-lg" v-model="showModal" size="lg" :title="$t('pages.metadata.add')"
                title-class="font-18" hide-footer>
                <form @submit.prevent="addMetadata">
                  <div class="row">
                    <div class="col">
                      <label>{{
                        $t("pages.documentType.heading")
                        }}</label>
                      <input type="text" v-model.trim="label" class="form-control" required />
                    </div>
                  </div>
                  <div class="row mt-4 mb-12">
                    <div class="col">
                      <label>{{ $t("pages.documentType.type") }}
                      </label>
                      <select class="form-control" v-model.trim="type">
                        <option v-for="(type, index) in types" :key="index" :value="type.value">
                          {{ $t(`pages.metadata.types.${type.type}`) }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div v-if="isList" class="row mt-4">
                    <div class="col">
                      <label for="">Options</label>
                      <a href="#" @click="showOptionModal = true" class="float-right text-success">
                        + {{ $t("pages.metadata.option.new_option") }}
                      </a>
                      <multiselect v-model="option" :options="options" :multiple="true" :tage-placeholder="
                          $t('pages.documentType.search')
                        " :placeholder="$t('pages.documentType.tag')" label="label" track-by="id" :taggable="true">
                      </multiselect>
                      <div class="col-2">
                        <b-modal id="option-modal-lg" v-model="showOptionModal" size="lg"
                          :title="$t('pages.metadata.option.add')" title-class="font-18" hide-footer>
                          <form @submit.prevent="addOption">
                            <div class="row">
                              <div class="col">
                                <label>{{
                                  $t("pages.documentType.heading")
                                  }}</label>
                                <input type="text" v-model.trim="form.option.label" class="form-control" required />
                              </div>
                            </div>
                            <hr />
                            <div class="row">
                              <div class="col">
                                <button type="button" class="
                                    btn btn-outline-light btn-block
                                  " @click="closeOptionModal" data-dismiss="modal">
                                  {{ $t("pages.documentType.cancel") }}
                                </button>
                              </div>
                              <div class="col">
                                <button type="submit" v-if="this.isLoading === false" class="btn btn-primary btn-block">
                                  {{ $t("pages.documentType.save") }}
                                </button>
                                <button class="btn btn-primary btn-block" type="button" v-else disabled>
                                  <span class="
                                      spinner-border spinner-border-sm
                                    " role="status" aria-hidden="true"></span>
                                  {{ $t("pages.documentType.saving") }}
                                </button>
                              </div>
                            </div>
                          </form>
                        </b-modal>
                      </div>
                    </div>
                  </div>
                  <div class="custom-control custom-switch mt-4">
                    <div class="col mt-3 text-left">
                      <input type="checkbox" v-model="required" class="custom-control-input" id="customSwitch1" />
                      <label class="custom-control-label" for="customSwitch1">{{ $t("pages.documentType.required")
                        }}</label>
                    </div>
                  </div>
                  <hr />
                  <div class="row">
                    <div class="col">
                      <button type="button" class="btn btn-outline-light btn-block" @click="closeModal"
                        data-dismiss="modal">
                        {{ $t("pages.documentType.cancel") }}
                      </button>
                    </div>
                    <div class="col">
                      <button type="submit" v-if="this.isLoading === false" class="btn btn-primary btn-block">
                        {{ $t("pages.documentType.save") }}
                      </button>
                      <button class="btn btn-primary btn-block" type="button" v-else disabled>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ $t("pages.documentType.saving") }}
                      </button>
                    </div>
                  </div>
                </form>
              </b-modal>
            </div>
          </div>
          <br />
          <!-- <div class="row">
            <div class="col mt-4">
              <h6>
                <i class="bx bxs-check-circle text-success"></i>
                {{ $t("pages.documentType.instructions.description") }}
              </h6>
              <h6>
                <i class="bx bxs-check-circle text-success"></i>
                {{ $t("pages.documentType.instructions.display") }}
              </h6>
              <h6>
                <i class="bx bxs-check-circle text-success"></i>
                {{ $t("pages.documentType.instructions.new") }}
              </h6>
            </div>
          </div> -->
          <div class="mt-4 mb-2">
            <div class="row">
              <div class="col text-left">
                <button v-if="this.isLoading === false" type="submit" class="btn btn-primary">
                  {{ $t("pages.documentType.save") }}
                </button>
                <button class="btn btn-primary" type="button" v-else disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  {{ $t("pages.documentType.saving") }}
                </button>
                <router-link :to="{ name: 'DocumentTypes' }" class="btn btn-light ml-2">{{
                  $t("pages.documentType.cancel") }}</router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { mapActions } from "vuex";

export default {
  page: {
    title: "Document Types",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Multiselect,
  },

  data() {
    return {
      title: "pages.documentType.typeDocument",
      showModal: false,
      showOptionModal: false,
      selectedMetadata: {},
      types: [
        {
          type: "number",
          value: "number",
          text: this.$t("pages.metadata.types.number"),
        },
        {
          type: "string",
          value: "string",
          text: this.$t("pages.metadata.types.string"),
        },
        {
          type: "text",
          value: "text",
          text: this.$t("pages.metadata.types.text"),
        },
        {
          type: "date",
          value: "date",
          text: this.$t("pages.metadata.types.date"),
        },
        {
          type: "boolean",
          value: "boolean",
          text: this.$t("pages.metadata.types.boolean"),
        },
        {
          type: "list",
          value: "list",
          text: this.$t("pages.metadata.types.list"),
        },
        {
          type: "file",
          value: "file",
          text: this.$t("pages.metadata.types.file"),
        },
      ],
      items: [
        {
          text: "menuitems.dashboards.text",
        },
        {
          text: "pages.documentType.typeDocument",
        },
        {
          text: "pages.documentType.create",
          active: true,
        },
      ],
      label: "",
      type: "",
      required: false,
      forms: {
        metadatas: [],
        name: "",
        description: "",
        metadata: [],
      },
      form: {
        option: {
          label: "",
        },
      },
      isLoading: false,
      msgErr: "",
      isChecked: false,
      isList: false,
      option: [],
    };
  },
  computed: {
    options: function () {
      return this.$store.state.metadata.options;
    },
  },
  methods: {
    ...mapActions(["createDocumentType", "getMetadata", "createMetadata"]),
    onSubmit() {
      if (this.$can("create", "document-types")) {
        this.isLoading = true;
        let documentTypeCreate = new FormData();

        documentTypeCreate.append("name", this.forms.name);
        documentTypeCreate.append("description", this.forms.description);
        documentTypeCreate.append(
          "metadata",
          JSON.stringify(this.forms.metadatas)
        );

        this.createDocumentType(documentTypeCreate)
          .then((response) => {
            if (response.status == 201) {
              this.$toasted.success(
                this.$t("pages.documentType.actions.created")
              );
              this.isLoading = false;
              this.$router.push({ name: "DocumentTypes" });
            }
          })
          .catch((err) => {
            if (err.response.status == 422) {
              this.$toasted.error(
                this.$t("pages.documentType.actions.required")
              );
              this.isLoading = false;
            } else {
              this.isLoading = false;
              this.$toasted.error(this.$t("pages.unauthorized.error_0"));
            }
          });
      } else {
        this.$toasted.error(this.$t("pages.unauthorized.forbidden_1"));
      }
    },
    closeModal() {
      this.showModal = false;
      this.label = "";
      (this.type = ""), (this.required = false);
    },
    closeOptionModal() {
      this.showOptionModal = false;
    },
    addOption() {
      let data = new FormData();
      data.append("label", this.form.option.label);
      this.$store.dispatch("addOption", data).then(() => {
        this.closeOptionModal();
      });
    },
    addMetadata() {
      if (this.$can("create", "metadata")) {
        let formData = new FormData();
        formData.append("label", this.label);
        formData.append("type", this.type);
        formData.append("required", this.required);
        if (this.type === "list") {
          formData.append("options", JSON.stringify(this.option));
        }
        this.createMetadata(formData)
          .then((response) => {
            if (response.status === 201) {
              this.isLoading = false;
              this.$toasted.success(this.$t("pages.metadata.actions.created"));
              this.closeModal();
            }
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.isLoading = false;
              this.$toasted.error(this.$t("pages.metadata.actions.exists"));
            } else {
              this.isLoading = false;
              this.$toasted.error(this.$t("pages.unauthorized.error_0"));
            }
          });
      } else {
        this.$toasted.error(this.$t("pages.unauthorized.forbidden_1"));
      }
    },
    addTag(newTag) {
      const tag = {
        label: newTag,
        type: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.metadata.push(tag);
      this.forms.metadatas.push(tag);
    },
  },
  toggle: function () {
    this.required = !this.required;
  },
  watch: {
    type: function () {
      if (this.type === "list") {
        this.isList = true;
      }
    },
  },
  created() {
    this.getMetadata(this.$route.params.id)
      .then((response) => {
        if (response.status == 200) {
          this.isLoading = false;
          this.forms.metadata = response.data;
        } else {
          this.isLoading = false;
        }
      })
      .catch((error) => {
        console.log(error);
        this.isLoading = false;
      });
    this.$store.dispatch("getOptions").then(() => {});
  },
};
</script>

<style>
</style>